export const HAS_DATASTORE_HYDRATED = 'hasDatastoreHydrated';
export const AMPLIFY_LATEST_USER_ATTRIBUTES = 'amplify-latest-user-attributes';
export const BEACON_3PC_HELP_INSTRUCTIONS_MODAL = 'beacon-3PC-help-instructions-modal';
export const BEACON_NAVIGATION_MENU_COLLAPSED = 'beacon-navigation-menu-collapsed';
export const CRM_AUTOMATIC_LOGIN_PREFERENCE = 'crmAutomaticLoginEnabled';

export default {
  HAS_DATASTORE_HYDRATED,
  AMPLIFY_LATEST_USER_ATTRIBUTES,
  BEACON_3PC_HELP_INSTRUCTIONS_MODAL,
  BEACON_NAVIGATION_MENU_COLLAPSED,
  CRM_AUTOMATIC_LOGIN_PREFERENCE,
};
